import ImageKit from 'imagekit-javascript'

const SERVER = process.env.VUE_APP_SERVER
const publicKey = process.env.VUE_APP_IMAGEKIT_KEY
const folder = process.env.VUE_APP_IMAGEKIT_FOLDER

const urlEndpoint = 'https://ik.imagekit.io/asu'
const authenticationEndpoint = SERVER + '/api/aux/imagekit'

const imagekit = new ImageKit({
  publicKey,
  urlEndpoint,
  authenticationEndpoint,
})

class Lib {
  upload(file, fileName, dir) {
    return new Promise((resolve, reject) => {
      imagekit.upload(
        { file, fileName, folder: `${folder}/${dir}` },
        (err, result) => {
          if (err) reject(err)
          resolve(result.url)
        }
      )
    })
  }
  copy(id) {
    const el = document.querySelector(`#${id}`)

    if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
      const range = document.createRange()
      range.selectNodeContents(el)
      const selection = window.getSelection()
      selection.removeAllRanges()
      selection.addRange(range)
      el.setSelectionRange(0, 999999)
    } else el.select()

    document.execCommand('copy')
  }
  /**
   * @param {Date}  initialDate
   * @param {Date}  finalDate
   * @return {Number} Cantidad de días de diferencia
   */
  diffBetweenDates(initialDate, finalDate) {
    var d1 = new Date(initialDate).getTime()
    var d2 = new Date(finalDate).getTime()
    var diff = (d2 - d1) / 86400000
    // return diff
    return Number.parseInt(diff)
  }
}

export default new Lib()
